<template>
  <div v-if="shouldShow" class="image-viewer-container" :class="position">
    <div class="image-zoom-container">
      <img :src="image.label"
           :alt="image.value"
           class="viewer-image">
      <div class="zoom-indicator" @click="openImageModal">
        <i class="material-icons">zoom_in</i>
      </div>
    </div>

    <!-- Image Modal -->
    <div v-if="showModal" class="image-modal" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-image-container">
          <img :src="image.label" :alt="image.value" class="modal-image">
          <div class="modal-close" @click="closeModal">
            <i class="material-icons">close</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    image: {
      type: Object,
      required: true
    },
    position: {
      type: String,
      default: 'middle',
      validator: value => ['middle', 'top-left', 'top-right', 'left'].includes(value)
    },
    questionType: {
      type: String,
      default: ''
    },
    showImageOnTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showModal: false
    }
  },
  computed: {
    shouldShow () {
      return (this.questionType === 'csat' &&
             this.showImageOnTitle &&
             this.image &&
             this.position === this.imagePosition) || this.questionType === 'matrix'
    },
    imagePosition () {
      return this.position || 'middle'
    }
  },
  methods: {
    openImageModal () {
      this.showModal = true
      document.body.style.overflow = 'hidden'
    },
    closeModal () {
      this.showModal = false
      document.body.style.overflow = 'auto'
    }
  }
}
</script>

<style lang="scss">
.image-viewer-container {
  display: flex;
  justify-content: center;
  width: 100%;

  &.middle {
    /* margin-bottom: 30px; */
    padding: 10px;

    .image-zoom-container {
      width: 190px;
      height: 190px;
    }
  }

  &.top-left {
    position: relative;
    width: auto;
    padding: 10px;
  }

  &.top-right {
    position: relative;
    width: auto;
    padding: 10px;
  }

  &.left {
    position: relative;
    width: auto;
    padding: 5px;
    margin: 0;
  }

  .image-zoom-container {
    width: 140px;
    height: 140px;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.3s ease-out;

    &:hover {
      transform: scale(1.05);
    }

    .viewer-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .zoom-indicator {
      position: absolute;
      top: 6px;
      right: 6px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      width: 26px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.2s ease, transform 0.2s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      cursor: zoom-in;
      z-index: 4;

      @media (hover: none) {
        opacity: 0.7;
        background: rgba(255, 255, 255, 0.8);
      }

      i {
        font-size: 16px;
        color: #666;
      }

      &:hover {
        transform: scale(1.1);
      }
    }

    @media (hover: hover) {
      &:hover {
        .zoom-indicator {
          opacity: 1;
        }
      }
    }
  }

  .image-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 40px;
    animation: fadeIn 0.15s ease-out;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);

    .modal-content {
      position: relative;
      max-width: 90%;
      max-height: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      animation: zoomIn 0.15s ease-out;
      will-change: transform, opacity;

      .modal-image-container {
        position: relative;

        .modal-image {
          max-width: 100%;
          max-height: 50vh;
          object-fit: contain;
          border-radius: 8px;
        }

        .modal-close {
          position: absolute;
          top: -40px;
          right: -40px;
          width: 30px;
          height: 30px;
          background: rgba(255, 255, 255, 0.95);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.15s ease-out;

          i {
            font-size: 24px;
            color: #333;
          }

          &:hover {
            background: #fff;
            transform: scale(1.05);
          }
        }
      }
    }
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media only screen and (max-width: 850px) {
  .image-viewer-container {
    .image-zoom-container {
      width: 140px;
      height: 140px;
    }
  }
}

@media only screen and (max-width: 480px) {
  .image-viewer-container {
    .image-zoom-container {
      width: 140px;
      height: 140px;
    }
  }
}
</style>
